export default __webpack_public_path__ + "static/media/107.c832001e.png";